import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography, Grid, Dialog, Menu, MenuItem } 
from "@mui/material"; 
import dayjs from "dayjs";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import moment from "moment";
import { ConvertText } from "../../services/utility";
import AccessLocalStorage from "../../services/localStorage";
//import { useStyles } from "../../style";
import { getApiUrl } from "../../services/api_service";
import { DateRangeChangeDirection, SeizureReportDateRange, SeizureTypeReportRangeType } from "./enums";
import { renderRecoveryTimeBackToNormalType, renderSeizureArmInvolvedType, renderSeizureAwarenessType, renderSeizureBodyType, renderSeizureEyeInvolvedType, renderSeizureFaceInvolvedType, renderSeizureLegInvolvedType, SeizureTypeDetails } from "../patient_profile/seizure_diary";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { dashboardText, mainGrid, primaryColor } from "../../style2";

export function BasicMenu({ point, onSelectEntry }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleEntryClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleEntryClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button" aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleEntryClick} style={{ color: "#26575C" }}
      >
        {point.diaryEntries.length} Entries <ArrowDropDownIcon style={{ marginLeft: "4px" }} />
      </Button>
      <Menu id="entry-menu" anchorEl={anchorEl} open={open} onClose={handleEntryClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }} >
        {point.diaryEntries && point.diaryEntries.map((entry, idx2) => {
          return <MenuItem sx={primaryColor} onClick={() => { onSelectEntry(entry); handleEntryClose() }}>Entry {idx2 + 1}</MenuItem>;
        })}
      </Menu>
    </div>
  );
}

export function SeizureReportByType() {
  const [display, setDisplay] = useState(SeizureTypeReportRangeType.Weekly);
  const dayOffset = 6, weekOffset = 4, monthOffset = 3;
  const [startDate, setStartDate] = useState(dayjs().subtract(weekOffset, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [reportData, setReportData] = useState(null);
  const [loadingReportData, setLoadingReportData] = useState(false);
  const [errorReportData, setErrorReportData] = useState('');
  const ls = new AccessLocalStorage();
  const [selectedEntry, setSelectedEntry] = useState(null);

  const handleDateRangeChange = (direction) => {
    if (display === SeizureTypeReportRangeType.Daily) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      if (direction === DateRangeChangeDirection.Left) {
        setStartDate(start.subtract(dayOffset, "day").format("YYYY-MM-DD"));
        setEndDate(end.subtract(dayOffset, "day").format("YYYY-MM-DD"));
      } else if (direction === DateRangeChangeDirection.Right) {
        setStartDate(start.add(dayOffset, "day").format("YYYY-MM-DD"));
        setEndDate(end.add(dayOffset, "day").format("YYYY-MM-DD"));
      } else if (direction === DateRangeChangeDirection.Today) {

        setStartDate(dayjs().subtract(dayOffset, 'day').format("YYYY-MM-DD"));
        setEndDate(dayjs().format("YYYY-MM-DD"));
      }

    } else if (display === SeizureTypeReportRangeType.Weekly) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      if (direction === DateRangeChangeDirection.Left) {
        setStartDate(start.subtract(weekOffset, "week").format("YYYY-MM-DD"));
        setEndDate(end.subtract(weekOffset, "week").format("YYYY-MM-DD"));
      } else if (direction === DateRangeChangeDirection.Right) {
        setStartDate(start.add(weekOffset, "week").format("YYYY-MM-DD"));
        setEndDate(end.add(weekOffset, "week").format("YYYY-MM-DD"));
      } else if (direction === DateRangeChangeDirection.Today) {

        setStartDate(dayjs().subtract(weekOffset, 'week').format("YYYY-MM-DD"));
        setEndDate(dayjs().format("YYYY-MM-DD"));
      }
    } else if (display === SeizureTypeReportRangeType.Monthly) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      if (direction === DateRangeChangeDirection.Left) {
        setStartDate(start.subtract(monthOffset, "month").format("YYYY-MM-DD"));
        setEndDate(end.subtract(monthOffset, "month").format("YYYY-MM-DD"));
      } else if (direction === DateRangeChangeDirection.Right) {
        setStartDate(start.add(monthOffset, "month").format("YYYY-MM-DD"));
        setEndDate(end.add(monthOffset, "month").format("YYYY-MM-DD"));
      }
      else if (direction === DateRangeChangeDirection.Today) {

        setStartDate(dayjs().subtract(monthOffset, 'month').format("YYYY-MM-DD"));
        setEndDate(dayjs().format("YYYY-MM-DD"));
      }
    }
  };

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      return;
    }

    if(display == null)
      return;
    setLoadingReportData(true);
    setErrorReportData('');
    let error = 'Unable to load seizure information.';
    fetch(
      `${getApiUrl()}/seizurediary/reportbyseizuretype/${ls.getCurrentPatientId()}?range=${SeizureReportDateRange.Custom}&display=${display}&startDate=${startDate}&endDate=${endDate}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            setReportData(data);
            //console.log("Report data:");
            //console.log(data);
          }).catch((err) => {
            setErrorReportData(error);
            console.log(err);
          });
        } else {
          setErrorReportData(error);
        }
      })
      .catch((err) => {
        setErrorReportData(error);
        console.log(err);
      })
      .finally(() => { setLoadingReportData(false); });
  }, [startDate, endDate, display]);

  const tableHeaderCell = { color: "#26575C", fontWeight: "bold", fontSize: "1.2rem", border: "none" };
  const tableBodyCell = { color: "#26575C", fontWeight: "bold", fontSize: "1rem", border: "none", minWidth: "165px", width: display === SeizureTypeReportRangeType.Daily ? "165px" : display === SeizureTypeReportRangeType.Weekly ? "220px" : "275px" };
  const tbg = {
    borderRadius: "50px", // pill shape
    overflow: "hidden",   // ensures rounded corners apply to children
    border: "3px solid #E3E7E8"
  };
  const tb = {
    paddingTop: "10px",
    paddingBottom: "10px",
    //borderRight: "1px solid #26575C", // inner divider
    width: "130px",
    borderRight: "1px solid #26575C", // inner divider

    "&.Mui-selected": {
      backgroundColor: "#E4F2F2",
      color: "#26575C",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#E4F2F2", // keep same on hover
    },
  };
  const lpStyle = {
    "&.MuiLinearProgress-root": {
      backgroundColor: "#E3E7E8",
    },

    "& .MuiLinearProgress-bar": {
      backgroundColor: "#26575C",
    },
    height: 10, // optional thickness
    borderRadius: 5, // optional rounded corners
  };
  const dateDirBtn = {
    padding: "10px",
    backgroundColor: "#E4F2F2",   // ✅ background
    color: "#26575C",             // ✅ text/icon color
    "&:hover": {
      backgroundColor: "#d0e6e6", // optional hover shade
    }
  };

  const handleAlignment = (event, newAlignment) => {
    if(newAlignment == null)
      return;
    setDisplay(newAlignment);
    if (newAlignment === SeizureTypeReportRangeType.Weekly) {
      setStartDate(dayjs().subtract(4, 'week').format('YYYY-MM-DD'));
      setEndDate(dayjs().format('YYYY-MM-DD'));
    } else if (newAlignment === SeizureTypeReportRangeType.Monthly) {
      setStartDate(dayjs().subtract(3, 'month').format('YYYY-MM-DD'));
      setEndDate(dayjs().format('YYYY-MM-DD'));
    }
    else if (newAlignment === SeizureTypeReportRangeType.Daily) {
      setStartDate(dayjs().subtract(6, 'day').format('YYYY-MM-DD'));
      setEndDate(dayjs().format('YYYY-MM-DD'));
    }
  };

  const renderShowEntry = () => {
    if (selectedEntry !== null) {
      return <Dialog open={true} onClose={() => { setSelectedEntry(null); }} fullWidth maxWidth="md">
        <Grid container style={{
          backgroundColor: "#fff",
          padding: "10px 20px",
          position: "sticky",
          top: 0,
          zIndex: 10
        }}>
          <Grid item xs={11} >
            <Typography title="Entry Date" style={{ fontWeight: "bold", color: "rgb(241, 111, 111)", fontSize: "17px" }}>
              Seizure Diary - {dayjs(selectedEntry.entryDate).format("DD/MM/YY")}
            </Typography>
          </Grid>
          <Grid item xs={1} style={{ textAlign: "right", cursor: "pointer" }}>
            <CloseIcon onClick={() => { setSelectedEntry(null); }} />
          </Grid>
        </Grid>
        <Grid style={{
          padding: "10px 20px",
          maxHeight: "70vh",   // adjust height as needed
          overflowY: "auto"
        }}>
          <Typography component="div" style={{ fontWeight: "bold", marginBottom: "10px" }}>Seizure Type</Typography>
          {selectedEntry.seizureTypes && selectedEntry.seizureTypes.length > 0 &&
            selectedEntry.seizureTypes.map((st, index) => {
              return <SeizureTypeDetails key={index}
                seizureType={st}
                renderers={{
                  renderSeizureBodyType,
                  renderSeizureArmInvolvedType,
                  renderSeizureAwarenessType,
                  renderSeizureEyeInvolvedType,
                  renderSeizureLegInvolvedType,
                  renderSeizureFaceInvolvedType
                }}
              />
            })}
          <Grid container spacing={2} style={{ marginTop: "10px", marginBottom: "10px" }}>
            {selectedEntry.numberofSeizures > 0 ? <Grid item xs={12} md={6} >
              <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Number of Seizures</Typography>
              <Typography component="div" style={{ marginBottom: "5px" }}>{selectedEntry.numberofSeizures} </Typography>
            </Grid> : null}

            <Grid item xs={12} md={6} >
              <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Length Of Seizure</Typography>
              <Typography component="div" style={{ marginBottom: "5px" }}>{selectedEntry.lengthOfSeizure} </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Time Occured</Typography>
              <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>{selectedEntry.timeOccuredDisplay} </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Recovery Medication</Typography>
              <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>{selectedEntry.recoveryMedication ? "Yes" : "No"}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography component="div" style={{ fontWeight: "bold", marginBottom: "5px" }}>Recovery Back to Normal</Typography>
              <Typography fontWeight="bold" style={{ marginBottom: "5px" }}>
                {renderRecoveryTimeBackToNormalType(selectedEntry.recoveryTimeBackToNormalType)}
              </Typography>
            </Grid>
          </Grid>
          {selectedEntry.note !== "" && selectedEntry.note !== null ? <>
            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "10px" }}>Notes</Typography>
            <Box style={{ padding: "10px 5px", margin: "10px 0px ", borderTop: "1px solid gainsboro", borderBottom: "1px solid gainsboro" }}>
              <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{selectedEntry.note}</Typography>
            </Box></> : null}
          {selectedEntry.triggers && selectedEntry.triggers.list && selectedEntry.triggers.list.length > 0 ? <>
            <Typography component="div" style={{ fontWeight: "bold", marginBottom: "10px" }}>Possible Tiggers</Typography>
            <Box style={{ padding: "10px 5px", margin: "10px 0px ", borderTop: "1px solid gainsboro", borderBottom: "1px solid gainsboro" }}>
              {selectedEntry.triggers.list.map((trigger, index) => {
                if (trigger.name.toLowerCase() === "other") { return null; }
                return <Box key={index}>
                  <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{trigger.displayName}</Typography>
                </Box>;
              })}
              {selectedEntry.triggers.other && selectedEntry.triggers.other !== "" ? <Typography style={{ color: "rgb(79, 191, 168)", fontSize: "17px", whiteSpace: "pre-line" }}>{selectedEntry.triggers.other}</Typography> : null}
            </Box>
          </> : null}
          <Grid container fullWidth >
            <Grid item xs={6}>
              <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px" }}>
                <span style={{ marginRight: "15px" }}>Created on</span> {moment.utc(selectedEntry.createdAt).local().format("DD/MM/YYYY h:mm A")}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography style={{ color: "rgb(84, 84, 84)", fontSize: "15px", textAlign: "right" }}>
                Entered by - {selectedEntry.createdByName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>;
    }
    return null;
  }

  function getTableCellWidth(display) {
    if (display === SeizureTypeReportRangeType.Daily) {
      return "165px";
    } else if (display === SeizureTypeReportRangeType.Weekly) {
      return "220px";
    } else if (display === SeizureTypeReportRangeType.Monthly) {
      return "275px";
    }

  }

  return <Box mt={3}>
    <Box display="flex" alignItems="center"  >
      <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
        Frequency by Seizure Type
      </Typography>
    </Box>
    <Box m={2} />
    <Box sx={mainGrid}>
      <Box display="flex" alignItems="center">
        <Typography
          sx={{...dashboardText, fontSize: "1.4rem", fontWeight: "normal" }}
          component="div"
          marginLeft={1}
        >
          {display === SeizureTypeReportRangeType.Weekly
            ? 'Weekly View'
            : display === SeizureTypeReportRangeType.Monthly
              ? 'Monthly View'
              : 'Daily View'
          }
        </Typography>
        <Box flexGrow={1} />
        <Typography
          sx={{...dashboardText, fontSize: "1.4rem", fontWeight: "normal" }}
          component="div"
        >
          {dayjs(startDate).year() === dayjs(endDate).year()
            ? dayjs(startDate).year()
            : `${dayjs(startDate).year()} - ${dayjs(endDate).year()}`}
        </Typography>
      </Box>
      <Box my={2} display="flex" justifyContent="flex-start">
        <ToggleButtonGroup disabled={loadingReportData} value={display} exclusive onChange={handleAlignment} aria-label="text alignment" style={tbg}>
          <ToggleButton value={SeizureTypeReportRangeType.Daily} aria-label="left aligned" style={tb}>
            Daily
          </ToggleButton>
          <ToggleButton value={SeizureTypeReportRangeType.Weekly} aria-label="left aligned" style={tb}>
            Weekly
          </ToggleButton>
          <ToggleButton value={SeizureTypeReportRangeType.Monthly} aria-label="right" style={tb}>
            Monthly
          </ToggleButton>

        </ToggleButtonGroup>
        {loadingReportData ? <Box mx={2}><CircularProgress size="2rem" mt={2} /></Box> : null}
        <Box ml="auto">
          <ButtonGroup disabled={loadingReportData} variant="contained" aria-label="Basic button group" style={tbg}>
            <Button style={dateDirBtn} onClick={() => { handleDateRangeChange(DateRangeChangeDirection.Left) }}><KeyboardArrowLeftOutlinedIcon /></Button>
            <Button style={dateDirBtn} onClick={() => { handleDateRangeChange(DateRangeChangeDirection.Right) }}><KeyboardArrowRightOutlinedIcon /></Button>
            <Button style={dateDirBtn} onClick={() => { handleDateRangeChange(DateRangeChangeDirection.Today) }}>TODAY</Button>
          </ButtonGroup>
        </Box>
      </Box>
      {errorReportData !== '' ? <Box py={2}>
        <Typography style={{ color: "red" }}>{errorReportData}</Typography>
      </Box> : null}
      {reportData && reportData.length > 0 && reportData[0].dataPoints ?
        <TableContainer component={Paper}>
          <Table style={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#E4F2F2" }}>
                <TableCell style={tableHeaderCell}>Seizure Type</TableCell>
                {reportData[0].dataPoints.map((point) => {
                  return <TableCell align="center" key={point.rangeDisplay} style={{ ...tableHeaderCell, width: getTableCellWidth(display) }}>{point.rangeDisplay}</TableCell>;
                })}
              </TableRow>
              {/* Total Seizures Row */}
              <TableRow style={{ backgroundColor: "#F9F9F9" }}>
                <TableCell style={{...tableHeaderCell, fontWeight: 'bold'}}>Total Seizures</TableCell>
                {reportData[0].dataPoints.map((point, idx) => {
                  // Sum all counts for this column (rangeDisplay)
                  const total = reportData.reduce((sum, row) => {
                    const dp = row.dataPoints[idx];
                    return sum + (dp && typeof dp.count === 'number' ? dp.count : 0);
                  }, 0);
                  return <TableCell align="center" key={point.rangeDisplay + '-total'} style={tableHeaderCell}>{total}</TableCell>;
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Calculate totals for each column for use in progress bars */}
              {(() => {
                const totals = reportData[0].dataPoints.map((_, colIdx) =>
                  reportData.reduce((sum, row) => {
                    const dp = row.dataPoints[colIdx];
                    return sum + (dp && typeof dp.count === 'number' ? dp.count : 0);
                  }, 0)
                );
                return reportData.map((row, idx) => (
                  <TableRow key={idx} sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: "#F2FCFB",
                    },
                  }}>
                    <TableCell component="th" scope="row" style={tableBodyCell}>
                      {row.seizureType.seizureTypeName}
                      {row.seizureType.seizureTypeScientificName && row.seizureType.seizureTypeScientificName !== '' ? <Typography style={{ fontSize: "0.8rem" }}> ({row.seizureType.seizureTypeScientificName})</Typography> : null}
                    </TableCell>
                    {row.dataPoints.map((point, colIdx) => {
                      const total = totals[colIdx] || 1; // avoid division by zero
                      return <TableCell align="center" key={point.rangeDisplay} style={tableBodyCell}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Typography color="text.disabled">Freq</Typography>
                          <Typography variant="h6" fontWeight="bold">
                            {ConvertText(point.count, 0, "")}
                          </Typography>
                        </Box>
                        <LinearProgress variant="determinate" value={total > 0 ? (point.count / total) * 100 : 0} style={lpStyle} />
                      </TableCell>;
                    })}
                  </TableRow>
                ));
              })()}
              {(display == SeizureTypeReportRangeType.Daily || display == SeizureTypeReportRangeType.Weekly) && reportData.length >= 0 ? <TableRow sx={{
                "&:nth-of-type(odd)": {
                  backgroundColor: "#F2FCFB",
                },
              }}>
                <TableCell component="th" scope="row" style={tableBodyCell}>
                  Diary Entries
                </TableCell>
                {reportData[0].dataPoints.map((point, index) => {
                  return <TableCell align="center" key={index} style={tableBodyCell}>
                    {point.diaryEntries && point.diaryEntries.length === 1 ? <Button style={{ color: "#26575C" }} onClick={() => { setSelectedEntry(point.diaryEntries[0]); }}>
                      1 Entry
                    </Button> : null}
                    {point.diaryEntries && point.diaryEntries.length > 1 ? <>
                      <BasicMenu point={point} onSelectEntry={(entry) => { setSelectedEntry(entry); }} />
                    </> : null}

                    {/* {point.diaryEntries && point.diaryEntries.length > 1 ? <select
                      style={{ padding: "8px", marginRight: "10px", borderRadius: "0px", fontSize: "1.2rem", backgroundColor: "transparent", border: "0px", borderBottom: "1px solid #26575C" }}>
                      <option>
                          {point.diaryEntries.length} Entries
                          </option>
                      {point.diaryEntries && point.diaryEntries.map((entry, idx2) => {
                        return <option key={idx2} >Entry {idx2 + 1}</option>;
                      })}
                    </select> : null} */}

                  </TableCell>;
                })}
              </TableRow> : null}
            </TableBody>
          </Table>
        </TableContainer>
        : null}

      {renderShowEntry()}
    </Box>
  </Box>;
}